import * as React from "react";


export class ButtonGroup extends React.Component<{ actions?: string[], active?: string, onChange: (action: string) => void }, {}> {

    onClick(action: string) {
        this.props.onChange(action);
    }

    getActions() {
        return this.props.actions.map(a => {
            return <button key={a} onClick={this.onClick.bind(this, a)}
                           className={a == this.props.active ? "btn btn-primary" : "btn btn-white"}
                           type="button">{a}</button>
        });
    }

    render() {
        return (
            <div className="btn-group">
                {this.getActions()}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/app/ui/navbar/ButtonGroup.tsx